const timeline = ((w, d) => {
    'use strict';

    var $public = {};
    var $private = {};

    var timeline = (function() {

        $public.animate = function() {

            var timelineBanner = $(".timeline").children(".timeline-banner");
            $(".timeline-banner-align .timeline-comp").css({
                opacity: 0
            });

            if ($(window).innerWidth() <= 1023) {
                $(".timeline .timeline-banner-text").css({
                    opacity: 0
                });
            }

            $(".timeline-banner-align .timeline-comp").first().addClass("activeImage").css({
                opacity: 1
            });

            if ($(window).innerWidth() <= 1023) {
                $(".timeline .timeline-banner-text").eq(0).addClass("activeText").css({
                    opacity: 1
                });
            }
            
            var zindex = 10;
            var timelineBanners = [];
            var animating = false;

            for (var i = 0; i < timelineBanner.length; i++) {

                //adding div to create a scroll, this way can be changed futurally
                var hashCreate = timelineBanner.eq(i).attr("data-hash")
                $(".timeline").append('<div class="timeline-spacing" id="timeline-' + hashCreate + '"></div>');

                var totalTop = $(".timeline-spacing").height();
                var addTopTimeline = totalTop * i;

                //create object to use when scrollTop moves
                var createTimelineBanner = {};
                createTimelineBanner.banner = i;
                createTimelineBanner.top = addTopTimeline;
                createTimelineBanner.name = timelineBanner.eq(i).attr("data-hash");
                timelineBanners.push(createTimelineBanner);

                timelineBanner.eq(i).css({
                    "z-index": zindex,
                    top: addTopTimeline
                });

                //add class lastimeline to the last div created
                if (i === timelineBanner.length -1) {
                    timelineBanner.eq(i).addClass("lastTimeline");
                }

                zindex++;
            }

            // need to start first timeline with class active or selected another one
            timeline.defineMenu(totalTop);

            $(window).scroll(function() {
                if ($(window).innerWidth() <= 1023) {
                    
                    $('header').css('position', 'fixed');

                    $private.scrollActions($(this), totalTop, timelineBanners, timelineBanner);
                }
            });

            $('.timeline').scroll(function(){
                $('html, body').stop().animate({
                    'scrollTop': 0
                }, 10, 'linear');

                if ($(window).innerWidth() > 1023) {
                    if ($('.timeline-banner .timeline-banner-text.activeText').offset().top < 150) {
                        // if (!$('.timeline-banner-text.activeText').hasClass('now-show')) {
                        //     $('.timeline-banner-text.activeText').addClass('not-show').stop().animate({
                        //         opacity: 0,
                        //       }, 10);
                        // }
                    } else {
                        $('.timeline-banner-text.activeText').removeClass('not-show').stop().animate({
                            // opacity: 1,
                          }, 100);
                    }

                    $private.scrollActions($(this), totalTop, timelineBanners, timelineBanner);
                }
            })
        };

        $private.scrollActions = function(grid, totalTop, timelineBanners, timelineBanner){
            var topScroll = grid.scrollTop();
            timeline.defineMenu(totalTop);
            //update timelinebanner
            // timelineBanner = $(".timeline").children(".timeline-banner");
            //user object defined before to define new top movement

            $(timelineBanners).each(function(index,data) {
                var move = true;
                
                if(data.top > 0){
                    var newTop = data.top - topScroll;

                    if (newTop < 0) {
                        newTop = 0;
                        $(timelineBanner).removeClass("active");
                        $(timelineBanner).eq(data.banner).addClass("active");

                        var bottomLastTimeline = "220px";
                        var bottomTimelineLetters = "500px";
                        var topimelineLetters = "0";
                        var bottomTimelineStage = "11%";
                        if (widthDocument > 1023) {
                            bottomLastTimeline = "190px";
                            bottomTimelineLetters = "140px";
                            topimelineLetters = "auto";
                            bottomTimelineStage = "25px";
                        }
                        
                        if ($(timelineBanner).eq(data.banner).hasClass("lastTimeline")) {
                            if ($(window).innerWidth() <= 1023) {
                                $('header').css('position', 'relative');

                                $(".lastTimeline").css({
                                    position: "absolute",
                                    top: "auto",
                                    bottom: bottomLastTimeline
                                });

                                $(".timeline-letters").css({
                                    position: "absolute",
                                    top: "auto", 
                                    bottom: bottomTimelineLetters
                                });

                                $(".timeline-stage").css({
                                    position: "absolute",
                                    top: "auto",
                                    bottom: "220px"
                                });
                            } else {
                                $(".lastTimeline").css({
                                    position: "fixed",
                                    top: "auto",
                                    bottom: bottomLastTimeline
                                });
                            }

                            $(".timeline-letters-mobile").css({
                                position: "absolute",
                                top: "unset",
                                bottom: "10%"
                            });

                            var move = false;
                        }
                    }

                    if(move) {
                        $(timelineBanner).eq(data.banner).css({
                            position: "fixed",
                            bottom: "auto",
                            top: newTop
                        });
                        //need change display to fixed the stage
                        if ($(window).innerWidth() <= 1023) {
                            $(".timeline-stage").css({
                                position: "fixed",
                                top: "unset",
                                bottom: "0"
                            });

                            $(".timeline-letters").css({
                                position: "fixed",
                                bottom: "115px"
                            });
                        }

                        $(".timeline-letters-mobile").css({
                            position: "fixed",
                            top: "25%",
                            bottom: "auto"
                        });

                        var subNumber = totalTop / 4;

                        if (topScroll > (data.top - subNumber) && topScroll < data.top) {
                            if (!$(".timeline-banner-align .timeline-comp[data-hash=" + data.name + "]").hasClass("activeImage")){

                                timeline.transition(data.name, data.banner,false);
                            }
                        }

                        if (topScroll < (timelineBanners[1].top - subNumber)) {
                            if (!$(".timeline-banner-align .timeline-comp[data-hash=" + timelineBanners[0].name + "]").hasClass("activeImage")){

                                timeline.transition(timelineBanners[0].name,false,true);
                            }
                        }
                    }
                    // if you need to change the object
                    // timelineBanners[index].top = newTop;
                }

                if ($(window).innerWidth() <= 1023) {
                    if ($('.timeline-banner.lastTimeline').hasClass('active')) {
                        $('.timeline-letters-mobile').css('top', 'unset');
                        $('.timeline-banner-text').css('top', '37%');
                    } else {
                        $('.timeline-letters-mobile').css('top', '25%');
                        $('.timeline-banner-text').css('top', '37%');
                    }
                }
            });
        };

        $(window).scroll(function(){
            if ($(window).innerWidth() > 1023) {
                $('.timeline-stage').css('top', ($('.about-footer-timeline').offset().top - $(window).scrollTop()) - 200);
                $('.timeline-letters').css('top', ($('.about-footer-timeline').offset().top - $(window).scrollTop()) - 470);
            }
        });

        $public.transition = function(nameHash,banner,firstBanner) {

            if (widthDocument > 1023) {

                $(".activeImage").removeClass("activeImage").stop().animate({
                    opacity: 0,
                    left: "+=20",
                  }, 400, function() {
                });
            }else {
                $(".activeImage").removeClass("activeImage").stop().animate({
                    opacity: 0,
                  }, 400, function() {
                });
            }
            

            if (widthDocument <= 1023) {
                $(".timeline-banner-text").removeClass("activeText").stop().animate({
                    opacity: 0,
                }, 400, function() {
                });
            }

            //actives
            if (widthDocument > 1023) {
                $(".timeline-banner-align .timeline-comp[data-hash=" + nameHash + "]").addClass("activeImage").stop().animate({
                    opacity: 1,
                    left: "-=20",
                  }, 400, function() {
                    // Animation complete.
                });

                $('.timeline .timeline-banner-text.activeText').removeClass('activeText');
            } else {
                $(".timeline-banner-align .timeline-comp[data-hash=" + nameHash + "]").addClass("activeImage").stop().animate({
                    opacity: 1,
                  }, 400, function() {
                    // Animation complete.
                });
            }

            $(".timeline-banner[data-hash=" + nameHash + "]").find(".timeline-banner-text").addClass("activeText");

            if (widthDocument <= 1023) {
                $(".timeline-banner[data-hash=" + nameHash + "]").find(".timeline-banner-text").stop().animate({
                    opacity: 1,
                  }, 400, function() {
                    // Animation complete.
                });
            }
            if (!$(".timeline-banner[data-hash=" + nameHash + "]").find(".timeline-banner-text").hasClass('not-show')) {
                // $(".timeline-banner[data-hash=" + nameHash + "]").find(".timeline-banner-text").stop().animate({
                //     opacity: 1,
                //   }, 400, function() {
                //     // Animation complete.
                // });
            }

            $(".timeline-menu a").removeClass("active");


            // if (firstBanner) {
            //     $(".timeline-menu a").first().addClass("active");
            // } else {
                $(".timeline-menu a").eq(banner).addClass("active");
            // }
            
            if (widthDocument > 1023) {
                window.odMillenium.update(nameHash.substring(0,2));
            }
            window.odYear.update(nameHash.substring(0,4));
        }

        $public.defineMenu = function(totalTop) {
            var topScroll = $(window).scrollTop();

            //define first banner with active class
            if (topScroll < totalTop) {
                $(".timeline").children(".timeline-banner").removeClass("active");
                $(".timeline").children(".timeline-banner").first().addClass("active");
            }
            
            if(topScroll > 80) {
                // $(".timeline-menu").css({
                //     position : 'fixed'
                // });
            } else {
                $(".timeline-menu").css({
                    position : 'absolute'
                });
            }
        };

        $public.menuSmooth = function(totalTop) {
            $('a[href^="#"]').bind('click.smoothscroll',function (e) {
                e.preventDefault();

                $(".timeline-menu a").removeClass("active");

                var target = this.hash,
                $target = $(target);

                if ($(window).innerWidth() <= 1023) {

                    if ($(this).hasClass('is-mobile')) {
                        $('html, body').stop().animate({
                            'scrollTop': $('.timeline-banner.active').offset().top + $('.timeline-banner.active').innerHeight()
                        }, 900, 'swing', function () {
    
                        });
                    } else {
                        $('html, body').stop().animate({
                            'scrollTop': $target.offset().top-86
                        }, 900, 'swing', function () {
    
                        });
                    }
                } else {
                    $('.timeline').stop().animate({
                        'scrollTop': (parseInt($('.timeline').scrollTop()) - 90) + parseInt($target.offset().top) + 'px'
                    }, 900, 'swing', function () {

                    });
                }
            });
        };

        return $public;
    })();

// Global

window.timeline = timeline;
var widthDocument = $(document).width();

if ($(".timeline").length) {
    
    timeline.animate();
    timeline.menuSmooth();
    
    $('html, body').stop().animate({
        'scrollTop': 10
    }, 100, 'swing', function () {
        $('html, body').stop().animate({
            'scrollTop': 0
        }, 100, 'swing', function () {

        });
    });

    
    $("footer.footer").addClass("timeline-footer-content");

    if (widthDocument > 1023) {
        window.odMillenium = new Odometer({
          el: document.querySelector('.timeline-letters-number-millenium'),

          // Any option (other than auto and selector) can be passed in here
          format: '',
          theme: 'car'
        });
        window.odMillenium.update(19);

        window.odYear = new Odometer({
          el: document.querySelector('.timeline-letters-number-year'),

          // Any option (other than auto and selector) can be passed in here
          format: 'ddd',
          theme: 'car'
        });
    } else {
        window.odYear = new Odometer({
          el: document.querySelector('.timeline-letters-mobile-number'),

          // Any option (other than auto and selector) can be passed in here
          format: 'dddd',
          theme: 'car'
        });
    }
    
    window.odYear.update(1946);

    $( window ).resize(function() {
      var totalWidthDocument = $(document).width();
      if ( ((totalWidthDocument > 1023 && widthDocument < totalWidthDocument) && widthDocument < 1023) ||  ((totalWidthDocument < 1024 && widthDocument > totalWidthDocument) && widthDocument > 1023) ) {
        location.reload();
      }
    });
}
})(window, document)